module.exports = __webpack_public_path__ + "media/images/chrome-c76bb7894c1de36a9202f747bdd050b5.png";